import { FC } from 'react'
import {
  OrderTotalDue,
  OrderTotalWrapper,
} from '../order.styled'
import { OrderTotalProps } from '../order.types'
import { currencyFormatted } from '@yuno/sdk-web-core/dist/utils/currency-format'
import { useTranslation } from 'react-i18next'

export const OrderTotal: FC<OrderTotalProps> = ({ totalDue, currency }) => {
  const { t } = useTranslation()

  return (
    <OrderTotalWrapper>
      <OrderTotalDue>
        <span>{t('Total due')}</span>
        <span>{currencyFormatted(currency, totalDue)}</span>
      </OrderTotalDue>
    </OrderTotalWrapper>
  )
}
